var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { observable, computed } from 'mobx';
import _ from 'lodash';
import Model from './Model';
import OrganisationModel from './OrganisationModel';
import ValidationStatus from '../data/ValidationStatus';
import SystemFeatureToggle from '../data/SystemFeatureToggle';
import { Roles } from "../data/Roles";
/**
 *
 */
var UserModel = /** @class */ (function (_super) {
    __extends(UserModel, _super);
    function UserModel(data) {
        if (data === void 0) { data = { systemFeatureToggles: [] }; }
        var _this = _super.call(this, data) || this;
        _this._filterString = '';
        return _this;
    }
    /**
     *
     * @param data
     */
    UserModel.prototype.update = function (data) {
        var _this = this;
        if (!data)
            return;
        var keys = Object.keys(data);
        keys.map(function (key) {
            switch (key) {
                case 'organisations':
                    _this.organisations = data[key].map(function (organisationData) {
                        return new OrganisationModel(organisationData);
                    });
                    break;
                case 'createdTimestamp':
                case 'lastModifiedTimestamp':
                case 'userJoinedTimestamp':
                    _this[key] = new Date(data[key]);
                    break;
                case 'systemFeatureToggles':
                    _this[key] = data[key];
                    if (window.debug) {
                        _this[key].push(SystemFeatureToggle.DEBUG);
                    }
                    break;
                default:
                    _this[key] = data[key];
            }
        });
        this._filterString = this.fullName + ' ' + this.email;
    };
    Object.defineProperty(UserModel.prototype, "isValidated", {
        /**
         *
         * @return {boolean}
         */
        get: function () {
            return this.accountValidationStatus === ValidationStatus.VALIDATED;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UserModel.prototype, "requiresOnBoarding", {
        /**
         *
         * @return {boolean}
         */
        get: function () {
            return this.organisations.length === 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UserModel.prototype, "organisation", {
        /**
         *
         * @return OrganisationModel
         */
        get: function () {
            return this.organisations.length > 0 ? this.organisations[0] : null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UserModel.prototype, "fullName", {
        /**
         *
         * @return {string}
         */
        get: function () {
            return this.firstname + ' ' + this.lastname;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UserModel.prototype, "filterString", {
        /**
         *
         * @return {string}
         */
        get: function () {
            return this._filterString;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UserModel.prototype, "isOwner", {
        /**
         *
         * @return {boolean}
         */
        get: function () {
            return this.organisation.userRole === Roles.OWNER;
        },
        enumerable: false,
        configurable: true
    });
    /**
     *
     * @param systemFeatureToggle string
     * @return {*}
     */
    UserModel.prototype.hasSystemFeature = function (systemFeatureToggle) {
        return !!this.systemFeatureToggles.find(function (toggle) {
            return systemFeatureToggle === toggle;
        });
    };
    /**
     *
     * @param systemFeatureToggles Array
     * @return {*}
     */
    UserModel.prototype.hasAnySystemFeature = function (systemFeatureToggles) {
        var _this = this;
        return _.some(systemFeatureToggles, function (systemFeatureToggle) {
            return _this.hasSystemFeature(systemFeatureToggle);
        });
    };
    __decorate([
        observable
    ], UserModel.prototype, "id", void 0);
    __decorate([
        observable
    ], UserModel.prototype, "accountValidationStatus", void 0);
    __decorate([
        observable
    ], UserModel.prototype, "email", void 0);
    __decorate([
        observable
    ], UserModel.prototype, "username", void 0);
    __decorate([
        observable
    ], UserModel.prototype, "firstname", void 0);
    __decorate([
        observable
    ], UserModel.prototype, "lastname", void 0);
    __decorate([
        observable
    ], UserModel.prototype, "password", void 0);
    __decorate([
        observable
    ], UserModel.prototype, "createdTimestamp", void 0);
    __decorate([
        observable
    ], UserModel.prototype, "lastModifiedTimestamp", void 0);
    __decorate([
        observable
    ], UserModel.prototype, "userRole", void 0);
    __decorate([
        observable
    ], UserModel.prototype, "userJoinedTimestamp", void 0);
    __decorate([
        observable
    ], UserModel.prototype, "organisations", void 0);
    __decorate([
        observable
    ], UserModel.prototype, "systemFeatureToggles", void 0);
    __decorate([
        computed
    ], UserModel.prototype, "isValidated", null);
    __decorate([
        computed
    ], UserModel.prototype, "requiresOnBoarding", null);
    __decorate([
        computed
    ], UserModel.prototype, "organisation", null);
    __decorate([
        computed
    ], UserModel.prototype, "fullName", null);
    return UserModel;
}(Model));
export default UserModel;
